import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from './ui/dialog';
import ListingCard from './ListingCard';

/**
 * Modal showing the listings that currently match a given alert.
 * Extracted from AlertsPage.
 */
export default function AlertMatchesModal({ open, onOpenChange, matches }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-card border-border max-w-4xl max-h-[80vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="font-playfair text-xl">
            Matching Materials ({matches.length})
          </DialogTitle>
          <DialogDescription>
            Materials currently available that match your alert criteria.
          </DialogDescription>
        </DialogHeader>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-4">
          {matches.map((listing) => (
            <ListingCard key={listing.listing_id} listing={listing} />
          ))}
        </div>
        {matches.length === 0 && (
          <p className="text-center text-muted-foreground py-8">
            No current matches. We'll notify you when new items are listed!
          </p>
        )}
      </DialogContent>
    </Dialog>
  );
}
